import { FC } from "react";
import { Col, Input, Row } from "antd";
import { useTypedSelector } from "@hooks";

import Modal from "@components/Modal";
import { IModal } from "@types";
import { useFetchComparatorDataQuery } from "@/services";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";

const InternalComparatorData: FC<IModal> = ({ isVisible, setIsVisible }) => {
  const offer = useTypedSelector(state => state?.offers?.offer);
  const user = useTypedSelector(state => state.auth?.user);

  const company_id = user?.company?.id;
  const offer_id = offer?.id;

  const { data } = useFetchComparatorDataQuery(
    {
      company_id,
      offer_id,
    },
    { skip: !company_id || !offer_id }
  );

  const internalComparator =
    data?.data?.internal_comparator_data || {};

  // 🔥 Transform backend object → UI-friendly array
  const comparatorSections = Object.entries(internalComparator)
    .filter(([key, value]: any) => {
      if (key !== "internal_employee_classification_type") return true;

      return [value?.min, value?.avg ?? value?.mid, value?.max].some(
        v => v !== null && v !== undefined && v !== ""
      );
    })
    .map(([key, value]: any) => {
      const grade = offer?.offer_position_detail?.grade;
      const range_type = offer?.offer_position_detail?.range_type;

      const titleMap: Record<string, string> = {
        internal_salary_range: `Internal Salary Range - Grade ${grade}`,
        internal_payroll_grade: `Internal Payroll Spread - Grade ${grade}`,
        internal_payroll_function: "Internal Payroll Spread - Functional",
        internal_employee_classification_type:
          `Internal Payroll Spread - ${range_type}`,
      };

      return {
        title: titleMap[key] || key,
        data: value,
        midKey: key === "internal_salary_range" ? "mid" : "avg",
      };
    }
    );
  // const comparatorSections = Object.entries(internalComparator).map(
  //   ([key, value]: any) => {
  //     const grade = offer?.offer_position_detail?.grade;
  //     const range_type = offer?.offer_position_detail?.range_type;

  //     const titleMap: Record<string, string> = {
  //       internal_salary_range: `Internal Salary Range - Grade ${grade}`,
  //       internal_payroll_grade: `Internal Payroll Spread - Grade ${grade}`,
  //       internal_payroll_function: "Internal Payroll Spread - Functional",
  //       internal_employee_classification_type:
  //         `Internal Payroll Spread - ${range_type}`,
  //     };

  //     return {
  //       title: titleMap[key] || key,
  //       data: value,
  //       midKey: key === "internal_salary_range" ? "mid" : "avg",
  //     };
  //   }
  // );

  return (
    <Modal
      mode="versions"
      footer={null}
      title="Internal Comparator Data"
      isVisible={isVisible}
      width={855}
      setIsVisible={setIsVisible}
    >
      <div className="px-10 py-10">
        {comparatorSections.map((section, index) => (
          <div className="offers__modal__row" key={index}>
            <div className="offers__modal__title">{section.title}</div>

            <Row justify="space-between" className="mb-10">
              <Col span={7}>
                <label>Minimum</label>
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    section.data?.min ?? ""
                  )}
                  size="large"
                />
              </Col>

              <Col span={7}>
                <label>Midpoint</label>
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    section.data?.[section.midKey] ?? ""
                  )}
                  size="large"
                />
              </Col>

              <Col span={7}>
                <label>Maximum</label>
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    section.data?.max ?? ""
                  )}
                  size="large"
                />
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default InternalComparatorData;